<div class="lottery-container">
    <!-- 頁面標題 -->
    <div class="page-header">
        <h2 class="page-title">抽獎指定中獎管理</h2>
        <span class="subtitle">篩選用戶並指定中獎</span>
    </div>

    <!-- 篩選區域 -->
    <div class="filter-panel">
        <div class="filter-title">
            <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .39.812l-4.89 6.11V13.5a.5.5 0 0 1-.24.425l-2 1.2A.5.5 0 0 1 6.5 14.7V7.922L1.61 1.812A.5.5 0 0 1 1.5 1.5z"/>
            </svg>
            篩選條件
        </div>

        <div class="filter-row">
            <!-- 活動篩選 -->
            <div class="filter-group">
                <label class="filter-label">活動</label>
                <div class="filter-with-btn">
                    <div class="filter-select activity-select" (click)="toggleActivityDropdown()">
                        <ng-container *ngIf="getSelectedActivity(); else noActivity">
                            <img loading="lazy" [src]="getSelectedActivity()!.gift_pic" class="gift-option-img" alt="">
                            <span>{{ getSelectedActivity()!.activity_name }}</span>
                        </ng-container>
                        <ng-template #noActivity>
                            <span>未篩選活動</span>
                        </ng-template>
                    </div>
                    <div class="dropdown-backdrop" *ngIf="showActivityDropdown" (click)="showActivityDropdown = false"></div>
                    <div class="activity-dropdown" *ngIf="showActivityDropdown">
                        <div class="gift-option"
                             [class.selected]="!filterObj.activityId"
                             (click)="selectActivity(null); $event.stopPropagation()">
                            <span>未篩選活動</span>
                        </div>
                        <div class="gift-option" *ngFor="let activity of activityList"
                             [class.selected]="filterObj.activityId === activity.id"
                             (click)="selectActivity(activity); $event.stopPropagation()">
                            <img loading="lazy" [src]="activity.gift_pic" class="gift-option-img" alt="">
                            <span>{{ activity.activity_name }}</span>
                        </div>
                    </div>
                    <button class="btn-add-activity" (click)="openAddActivityModal()">+</button>
                    <button class="btn-ranklist" *ngIf="filterObj.activityId" (click)="openRanklist()">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M3 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H3zm1 1h8v14H4V1zm2 2v2h4V3H6zm0 3v1h4V6H6zm0 2v1h4V8H6zm0 2v1h2v-1H6z"/>
                        </svg>
                        排行榜
                    </button>
                </div>
            </div>

            <!-- 禮物篩選 -->
            <div class="filter-group">
                <label class="filter-label">禮物類型</label>
                <div class="filter-select gift-select"
                     [class.gift-locked]="giftLockedByActivity"
                     (click)="toggleGiftDropdown()">
                    <ng-container *ngIf="getSelectedGift(); else noGift">
                        <img loading="lazy" [src]="getSelectedGift()!.pic" class="gift-option-img" alt="">
                        <span>{{ getSelectedGift()!.name }}</span>
                    </ng-container>
                    <ng-template #noGift>
                        <span>全部禮物</span>
                    </ng-template>
                    <span *ngIf="giftLockedByActivity" class="gift-lock-icon" title="由活動設定，不可變更">🔒</span>
                </div>
                <div class="dropdown-backdrop" *ngIf="showGiftDropdown" (click)="showGiftDropdown = false"></div>
                <div class="gift-dropdown" *ngIf="showGiftDropdown">
                    <div class="gift-option"
                         [class.selected]="!filterObj.giftID"
                         (click)="selectGift(null); $event.stopPropagation()">
                        <span>全部禮物</span>
                    </div>
                    <div class="gift-option" *ngFor="let gift of giftList"
                         [class.selected]="filterObj.giftID === gift.id"
                         (click)="selectGift(gift); $event.stopPropagation()">
                        <img loading="lazy" [src]="gift.pic" class="gift-option-img" alt="">
                        <span>{{ gift.name }}</span>
                    </div>
                </div>
            </div>

            <!-- 數量篩選 -->
            <div class="filter-group">
                <label class="filter-label">最低數量</label>
                <input type="number" class="filter-input" placeholder="輸入最低數量"
                       [(ngModel)]="filterObj.minCount"
                       (input)="onFilterChange()"
                       min="0">
            </div>

            <!-- 用戶ID搜尋 -->
            <div class="filter-group">
                <label class="filter-label">用戶ID / 暱稱</label>
                <input type="text" class="filter-input" placeholder="搜尋用戶..."
                       [(ngModel)]="filterObj.searchKeyword" (input)="onFilterChange()">
            </div>

            <!-- 查詢與重置按鈕 -->
            <div class="filter-group filter-actions-inline">
                <label class="filter-label">&nbsp;</label>
                <div class="filter-btns">
                    <button class="btn-filter" (click)="applyFilter()">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        </svg>
                        查詢
                    </button>
                    <button class="btn-reset" (click)="resetFilter()">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                        </svg>
                        重置
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- 統計摘要 -->
    <div class="stats-bar">
        <div class="stat-item">
            <span class="stat-label">篩選結果</span>
            <span class="stat-value">{{ totalCount }}</span>
            <span class="stat-unit">人</span>
        </div>
        <div class="stat-item">
            <span class="stat-label">已指定中獎</span>
            <span class="stat-value highlight">{{ getWinnerCount() }}</span>
            <span class="stat-unit">人</span>
        </div>
    </div>

    <!-- 用戶列表 -->
    <div class="user-table-wrapper">
        <table class="user-table" style="display: table !important;" *ngIf="filteredUsers.length > 0">
            <thead>
                <tr>
                    <th class="th-index">#</th>
                    <th class="th-id">用戶ID</th>
                    <th class="th-avatar">頭像</th>
                    <th class="th-name">暱稱</th>
                    <th class="th-phone">電話</th>
                    <th class="th-gender">性別</th>
                    <th class="th-gift">禮物</th>
                    <th class="th-count sortable" (click)="toggleSort('num')">
                        數量
                        <span class="sort-icon" [class.active]="sortField === 'num'">
                            <ng-container *ngIf="sortField === 'num'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</ng-container>
                            <ng-container *ngIf="sortField !== 'num'">⇅</ng-container>
                        </span>
                    </th>
                    <th class="th-status sortable" (click)="toggleSort('is_lottery_winner')">
                        中獎狀態
                        <span class="sort-icon" [class.active]="sortField === 'is_lottery_winner'">
                            <ng-container *ngIf="sortField === 'is_lottery_winner'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</ng-container>
                            <ng-container *ngIf="sortField !== 'is_lottery_winner'">⇅</ng-container>
                        </span>
                    </th>
                    <th class="th-action">操作</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let user of filteredUsers; let i = index; trackBy: trackByUserId"
                    [class.winner-row]="user.is_lottery_winner">
                    <td class="td-index">{{ (currentPage - 1) * pageSize + i + 1 }}</td>
                    <td class="td-id">{{ user.uid }}</td>
                    <td class="td-avatar">
                        <div class="avatar-img avatar-placeholder" *ngIf="!user.profile_pic">
                            {{ user.name?.charAt(0) }}
                        </div>
                        <img loading="lazy" *ngIf="user.profile_pic" [src]="user.profile_pic" alt="avatar" class="avatar-img"
                             onerror="this.onerror=null;this.style.display='none'">
                    </td>
                    <td class="td-name">{{ user.name }}</td>
                    <td class="td-phone">{{ user.phone_num }}</td>
                    <td class="td-gender">
                        <span class="gender-badge" [ngClass]="user.gender == '1' ? 'male' : 'female'">
                            {{ user.gender == '2' ? '女' : '男' }}
                        </span>
                    </td>
                    <td class="td-gift">
                        <div class="gift-item">
                            <img loading="lazy" [src]="user.gift_pic" alt="gift" class="gift-img" *ngIf="user.gift_pic">
                            <span>{{ user.gift_name }}</span>
                        </div>
                    </td>
                    <td class="td-count">{{ user.num }}</td>
                    <td class="td-status">
                        <!-- 沒有選擇活動時顯示未知 -->
                        <span *ngIf="!filterObj.activityId" class="status-badge status-unknown">
                            未知
                        </span>
                        <!-- 有選擇活動時顯示中獎狀態 -->
                        <ng-container *ngIf="filterObj.activityId">
                            <span class="status-badge" [ngClass]="user.is_lottery_winner ? 'status-won' : 'status-none'">
                                {{ user.is_lottery_winner ? '已中獎' : '未中獎' }}
                            </span>
                            <span *ngIf="user.is_lottery_winner && user.lottery_rank" class="rank-badge">
                                {{ user.lottery_rank }}
                            </span>
                        </ng-container>
                    </td>
                    <td class="td-action">
                        <!-- 未選擇活動 或 未中獎：顯示指定中獎 -->
                        <button class="btn-assign"
                                *ngIf="!filterObj.activityId || !user.is_lottery_winner"
                                (click)="assignWinner(user)"
                                [disabled]="user.assigning">
                            <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.398-.588-2.797-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.138-.388 2.537-.72 3.935z"/>
                            </svg>
                            指定中獎
                        </button>
                        <!-- 已選擇活動 且 已中獎：顯示取消中獎與填寫資料 -->
                        <ng-container *ngIf="filterObj.activityId && user.is_lottery_winner">
                            <button class="btn-cancel" (click)="cancelWinner(user)">
                                <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                                取消中獎
                            </button>
                            <button class="btn-edit-info" (click)="editWinnerInfo(user)">
                                <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                                </svg>
                                填寫資料
                            </button>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- 空狀態 -->
        <div class="empty-state" *ngIf="filteredUsers.length === 0 && !loading">
            <svg width="64" height="64" fill="#c5b9a8" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                <path d="M4.285 12.433a.5.5 0 0 0 .683-.183A3.498 3.498 0 0 1 8 10.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 0 0 .866-.5A4.498 4.498 0 0 0 8 9.5a4.5 4.5 0 0 0-3.898 2.25.5.5 0 0 0 .183.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"/>
            </svg>
            <p>沒有符合條件的用戶</p>
        </div>
    </div>

    <!-- 分頁 -->
    <div class="pagination-bar" *ngIf="totalCount > 0">
        <button class="page-btn" [disabled]="currentPage === 1" (click)="goToPage(1)">
            &laquo;
        </button>
        <button class="page-btn" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
            &lsaquo;
        </button>
        <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 頁，共 {{ totalCount }} 筆</span>
        <button class="page-btn" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
            &rsaquo;
        </button>
        <button class="page-btn" [disabled]="currentPage === totalPages" (click)="goToPage(totalPages)">
            &raquo;
        </button>
    </div>

    <!-- Loading -->
    <div class="loading-overlay" *ngIf="loading">
        <div class="spinner"></div>
        <p>載入中...</p>
    </div>

    <!-- 確認彈窗 -->
    <div class="modal-overlay" *ngIf="showConfirm" (click)="closeConfirm()">
        <div class="modal-box" (click)="$event.stopPropagation()">
            <div class="modal-header-bar">
                <h3>{{ confirmTitle }}</h3>
            </div>
            <div class="modal-body-content">
                <p>{{ confirmMessage }}</p>
                <div class="confirm-user-info" *ngIf="confirmUser">
                    <div class="confirm-avatar avatar-placeholder" *ngIf="!confirmUser.profile_pic">
                        {{ confirmUser.name?.charAt(0) }}
                    </div>
                    <img loading="lazy" *ngIf="confirmUser.profile_pic" [src]="confirmUser.profile_pic" alt="avatar" class="confirm-avatar"
                         onerror="this.onerror=null;this.style.display='none'">
                    <div>
                        <strong>{{ confirmUser.name }}</strong>
                        <span class="confirm-uid">ID: {{ confirmUser.uid }}</span>
                    </div>
                </div>
                <!-- 選擇中獎活動 -->
                <div class="form-group form-group-dropdown" *ngIf="confirmType === 'assign'" style="margin-top: 16px;">
                    <label class="form-label">選擇中獎活動 <span style="color: #c45c5c;">*</span></label>
                    <div class="form-select activity-select" (click)="toggleConfirmActivityDropdown()">
                        <ng-container *ngIf="getSelectedConfirmActivity(); else noConfirmActivity">
                            <img loading="lazy" [src]="getSelectedConfirmActivity()!.gift_pic" class="gift-option-img" alt="">
                            <span>{{ getSelectedConfirmActivity()!.activity_name }}</span>
                        </ng-container>
                        <ng-template #noConfirmActivity>
                            <span class="placeholder-text">請選擇活動</span>
                        </ng-template>
                    </div>
                    <div class="dropdown-backdrop" *ngIf="showConfirmActivityDropdown" (click)="showConfirmActivityDropdown = false"></div>
                    <div class="modal-gift-dropdown" *ngIf="showConfirmActivityDropdown">
                        <div class="gift-option" *ngFor="let activity of activityList"
                             [class.selected]="selectedActivityId === activity.id"
                             (click)="selectConfirmActivity(activity); $event.stopPropagation()">
                            <img loading="lazy" [src]="activity.gift_pic" class="gift-option-img" alt="">
                            <span>{{ activity.activity_name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer-bar">
                <button class="btn-modal-cancel" (click)="closeConfirm()">取消</button>
                <button class="btn-modal-confirm"
                        (click)="confirmAction()"
                        [disabled]="confirmType === 'assign' && !selectedActivityId">確認</button>
            </div>
        </div>
    </div>

    <!-- 禮物不符警告彈窗 -->
    <div class="modal-overlay" *ngIf="showGiftMismatchWarning" (click)="closeGiftMismatchWarning()">
        <div class="modal-box" (click)="$event.stopPropagation()">
            <div class="modal-header-bar warning-header">
                <h3>⚠️ 禮物類型不符</h3>
            </div>
            <div class="modal-body-content">
                <p>目前搜尋的禮物類型與指定活動的禮物類型不同，確定要繼續嗎？</p>
                <div class="mismatch-compare">
                    <div class="mismatch-item">
                        <span class="mismatch-label">搜尋的禮物</span>
                        <div class="mismatch-gift" *ngIf="mismatchFilterGift">
                            <img loading="lazy" [src]="mismatchFilterGift.pic" class="gift-option-img" alt="">
                            <span>{{ mismatchFilterGift.name }}</span>
                        </div>
                    </div>
                    <div class="mismatch-arrow">≠</div>
                    <div class="mismatch-item">
                        <span class="mismatch-label">活動的禮物</span>
                        <div class="mismatch-gift" *ngIf="mismatchActivityGift">
                            <img loading="lazy" [src]="mismatchActivityGift.pic" class="gift-option-img" alt="">
                            <span>{{ mismatchActivityGift.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer-bar">
                <button class="btn-modal-cancel" (click)="closeGiftMismatchWarning()">取消</button>
                <button class="btn-modal-confirm btn-warning" (click)="confirmMismatchContinue()">繼續指定</button>
            </div>
        </div>
    </div>

    <!-- 填寫中獎資訊彈窗 -->
    <div class="modal-overlay" *ngIf="showWinnerInfoModal" (click)="closeWinnerInfoModal()">
        <div class="modal-box winner-info-modal" (click)="$event.stopPropagation()">
            <div class="modal-header-bar">
                <h3>填寫中獎資訊</h3>
            </div>
            <div class="modal-body-content">
                <div class="confirm-user-info" *ngIf="winnerInfoUser">
                    <div class="confirm-avatar avatar-placeholder" *ngIf="!winnerInfoUser.profile_pic">
                        {{ winnerInfoUser.name?.charAt(0) }}
                    </div>
                    <img loading="lazy" *ngIf="winnerInfoUser.profile_pic" [src]="winnerInfoUser.profile_pic" alt="avatar" class="confirm-avatar"
                         onerror="this.onerror=null;this.style.display='none'">
                    <div>
                        <strong>{{ winnerInfoUser.name }}</strong>
                        <span class="confirm-uid">ID: {{ winnerInfoUser.uid }}</span>
                    </div>
                </div>

                <div class="winner-info-form">
                    <div class="form-group">
                        <label class="form-label">收件人姓名</label>
                        <input type="text" class="form-input" placeholder="請輸入收件人姓名"
                               [(ngModel)]="winnerInfoForm.name">
                    </div>
                    <div class="form-group">
                        <label class="form-label">聯絡電話</label>
                        <input type="text" class="form-input" placeholder="請輸入聯絡電話"
                               [(ngModel)]="winnerInfoForm.phone">
                    </div>
                    <div class="form-group">
                        <label class="form-label">收件地址</label>
                        <input type="text" class="form-input" placeholder="請輸入收件地址"
                               [(ngModel)]="winnerInfoForm.address">
                    </div>
                    <div class="form-group">
                        <label class="form-label">獎項名次 (Rank)</label>
                        <input type="number" class="form-input" placeholder="請輸入獎項名次"
                               [(ngModel)]="winnerInfoForm.rank" min="0">
                    </div>
                    <div class="form-group">
                        <label class="form-label">備註</label>
                        <textarea class="form-textarea" rows="3" placeholder="其他備註資訊"
                                  [(ngModel)]="winnerInfoForm.notes"></textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer-bar">
                <button class="btn-modal-cancel" (click)="closeWinnerInfoModal()">取消</button>
                <button class="btn-modal-confirm" (click)="saveWinnerInfo()">儲存</button>
            </div>
        </div>
    </div>

    <!-- 新增活動彈窗 -->
    <div class="modal-overlay" *ngIf="showAddActivityModal" (click)="closeAddActivityModal()">
        <div class="modal-box" (click)="$event.stopPropagation()">
            <div class="modal-header-bar">
                <h3>新增活動</h3>
            </div>
            <div class="modal-body-content">
                <div class="form-group">
                    <label class="form-label">活動名稱 <span style="color: #c45c5c;">*</span></label>
                    <input type="text" class="form-input" placeholder="請輸入活動名稱"
                           [(ngModel)]="newActivityName">
                </div>
                <div class="form-group form-group-dropdown">
                    <label class="form-label">綁定禮物 <span style="color: #c45c5c;">*</span></label>
                    <div class="form-select gift-select" (click)="toggleActivityGiftDropdown()">
                        <ng-container *ngIf="getSelectedActivityGift(); else noActivityGift">
                            <img loading="lazy" [src]="getSelectedActivityGift()!.pic" class="gift-option-img" alt="">
                            <span>{{ getSelectedActivityGift()!.name }}</span>
                        </ng-container>
                        <ng-template #noActivityGift>
                            <span class="placeholder-text">請選擇禮物</span>
                        </ng-template>
                    </div>
                    <div class="dropdown-backdrop" *ngIf="showActivityGiftDropdown" (click)="showActivityGiftDropdown = false"></div>
                    <div class="modal-gift-dropdown" *ngIf="showActivityGiftDropdown">
                        <div class="gift-option" *ngFor="let gift of giftList"
                             [class.selected]="newActivityGiftId === gift.id"
                             (click)="selectActivityGift(gift); $event.stopPropagation()">
                            <img loading="lazy" [src]="gift.pic" class="gift-option-img" alt="">
                            <span>{{ gift.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer-bar">
                <button class="btn-modal-cancel" (click)="closeAddActivityModal()">取消</button>
                <button class="btn-modal-confirm"
                        (click)="saveActivity()"
                        [disabled]="!newActivityName.trim() || !newActivityGiftId">新增</button>
            </div>
        </div>
    </div>
</div>
